<template>
    <console-content max-width="1024">
        <v-row class="mt-4 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">
                <span v-if="board._id">게시글 상세</span>
                <span v-else>게시글 등록</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-row class="mt-2">
            <v-col cols="12" md="8" class="pr-md-1">
                <v-card class="mx-1">
                    <v-card-title class="tit tit--xs font-weight-bold">기본정보</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="board.subject" label="제목" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                        <div class="mt-6">
                            <v-date-field v-model="board.display.startDate" label="이벤트 시작일" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                        </div>
                        <div class="mt-6">
                            <v-date-field v-model="board.display.endDate" label="이벤트 마감일" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                        </div>
                        <div class="mt-6">
                            <v-select v-model="board.status" :disabled="!$hasScope(['root', 'admin'])" :items="statusItems" item-text="text" item-value="value" label="상태" persistent-placeholder hide-details/>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="4" class=" pl-md-1">
                <v-card class="mx-1 mt-3 mt-md-0">
                    <v-card-title>
                        <span class="tit tit--xs">상단고정</span>
                        <v-spacer/>
                        <v-switch v-model="board.isNotice" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                </v-card>
                <v-card class="mx-1 mt-3 mt-md-1">
                    <v-card-title>
                        <span class="tit tit--xs">댓글여부</span>
                        <v-spacer/>
                        <v-switch v-model="board.isComment" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col  class="pr-md-1">
                <v-card class="mx-1">
                    <v-card-title class="tit tit--xs font-weight-bold">썸네일</v-card-title>
                    <v-card-text>
                        <v-layout no-gutters align-center>
                            <v-img v-if="thumb" :src="thumb" max-width="96" height="auto" contain></v-img>
                            <v-sheet v-else width="96" height="96" color="d-flex justify-center align-center grey lighten-2"><v-icon>mdi-image</v-icon></v-sheet>
                            <v-file-input v-model="board.thumb" :disabled="!$hasScope(['root', 'admin'])" />
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mt-2">
            <v-col cols="12" class="pr-md-1">
                <v-card class="mx-1">
                    <v-card-title class="tit tit--xs font-weight-bold">이벤트 URL</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="board.url" label="URL" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder placeholder="이벤트 url을 입력하면 해다 url로 이동합니다." hide-details />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold">상세정보</v-card-title>
            <v-card-text>
                <naver-smarteditor v-model="board.content" />
            </v-card-text>
        </v-card>

        <v-row class="my-4">
            <v-spacer/>
            <v-col cols="auto" class="">
                <v-btn color="primary" :disabled="!$hasScope(['root', 'admin'])" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
export const EVENT_STATUS_ITEMS= {
    schedule : { text: "진행예정", value: "schedule" },
    open : { text: "진행중", value: "open" },
    close : { text: "진행완료", value: "close" },
    winner : { text: "당첨자 발표", value: "winner" }
};

const statusItems = Object.values(EVENT_STATUS_ITEMS);

export default {
    components: {
        ConsoleContent,
        NaverSmarteditor,
        VDateField
    },
    data(){
        return {
            board: {
                _id: this.$route.params._board,

                url: null,

                code: "event",
                subject: null,
                content: null,
                status: "schedule",

                display: {
                    startDate: null,
                    endDate: null
                },

                isNotice: false,
                isComment: false
            },
            statusItems
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.board._id){
                let { board } = await api.console.boards.get(this.board);
                if (board.thumb) board.thumb = await api.getResource(board.thumb)
                this.board = board;
            }
        },
        validate() {
            try {
                if (!this.board.subject) throw new Error("제목을 입력해주세요")
                if (!this.board.display.startDate) throw new Error("이벤트 시작일을 선택해주세요") 
                if (!this.board.thumb) throw new Error("썸네일을 선택해주세요")
                if (!this.board.content) throw new Error("상세정보를 입력해주세요") 
                return true;
            } catch (error) {
                alert(error.message)
                return false;
            }
        },
        async save(){
            if (this.validate()) {
                let { board } = this.board._id ? await api.console.boards.put({...this.board, thumb: null}) : await api.console.boards.post({...this.board, thumb: null});

                if(this.thumb){
                    let { thumb } = await api.console.boards.thumb.post(board._id, this.board.thumb);
                    board.thumb = thumb;
                }

                alert("저장되었습니다");
                this.$router.go(-1);
            }
        }
    },
    computed: {
        thumb(){
            try{
                return URL.createObjectURL(this.board.thumb);
            }
            catch(error){
                return null;
            }
        },
    }
}
</script>